import {
	isAnyActiveInvestorInMIP,
	updateMipInvestorsDeleted,
} from '@dealstack/frontend/shared/dataExchange/services/god.service';
import { logger } from '@dealstack/frontend/shared/mechanism/logger/logger';
import { useDSToast } from '@dealstack/frontend/shared/mechanism/toast/useDSToast';
import API_PATHS from '@dealstack/shared/lib/generated/apiPaths';
import { formatUnicorn } from '@dealstack/shared/lib/format/formatUnicorn';
import { useMutation, useQuery } from '@tanstack/react-query';
import { useCallback, useState } from 'react';

export const useMIPArchiveButton = (
	mipId: string,
	isMIPArchived: boolean,
	refetchMipData: () => void
) => {
	const toastAPI = useDSToast();
	const [showArchiveMIPConfirmationModal, setShowArchiveMIPConfirmationModal] = useState(false);
	const updateMipInvestorsDeletedRequest = useMutation({
		mutationFn: updateMipInvestorsDeleted,
	});

	const getIsAnyActiveInvestorInMIPRequest = useQuery({
		queryKey: [
			formatUnicorn(API_PATHS.GODMODE_MIP_MIPID_IS_ANY_INVESTOR_ACTIVE_GET, {
				mipId: mipId || '',
			}),
		],

		queryFn: ({ signal }) =>
			isAnyActiveInvestorInMIP(
				formatUnicorn(API_PATHS.GODMODE_MIP_MIPID_IS_ANY_INVESTOR_ACTIVE_GET, {
					mipId: mipId || '',
				}),
				signal
			),
		enabled: !!mipId,
	});

	const onSubmit = useCallback(() => {
		updateMipInvestorsDeletedRequest.mutate(
			{
				mipId,
			},
			{
				onError: (error) => {
					logger.error(error);
					toastAPI.error({
						message: "Data couldn't be updated!",
					});
				},
				onSuccess: () => {
					refetchMipData();
					toastAPI.success({
						message: 'Successfully updated!',
					});
				},
			}
		);
		setShowArchiveMIPConfirmationModal(false);
	}, [isMIPArchived]);

	return {
		isAnyInvestorActive: getIsAnyActiveInvestorInMIPRequest?.data?.payload?.isActive,
		showArchiveMIPConfirmationModal,
		setShowArchiveMIPConfirmationModal,
		onSubmit,
	};
};
